module.exports = __webpack_public_path__ + "static/media/currency.b29f9e3a.svg";